export default __webpack_public_path__ + "static/media/counselor.dd9f6791.jpg";